<template>
  <Message v-if="text && !hasRequests" severity="warn" :closable="false" data-testid="student-profile-reminder">
    <div class="flex flex-wrap items-center justify-between gap-3 w-full">
      <span>{{ text }}</span>
      <Button label="Fill them in" icon="pi pi-arrow-right" iconPos="right" size="small"
        @click="router.push(PROFILE_FORM_ROUTE)" data-testid="btn-profile-reminder" />
    </div>
  </Message>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useMyStudentProfileForm } from '@/composables/queries/useMyStudentProfileForm';
import { profileReminderText } from '@/utils/studentProfileForm';
import { useMyStudentDataRequests } from '@/composables/queries/useMyStudentDataRequests';
import { PROFILE_FORM_ROUTE, actionableRequests } from '@/utils/studentDataRequests';

/**
 * Reminds the student while required fields their school asked for are still
 * empty. Steps aside while a data request card says the same thing louder.
 */
const router = useRouter();
const { missingRequired } = useMyStudentProfileForm();
const { requests } = useMyStudentDataRequests();
const text = computed(() => profileReminderText(missingRequired.value));
const hasRequests = computed(() => actionableRequests(requests.value).length > 0);
</script>
